<template>
	<Col @mousedown.native="onContentClick" @click.native="onContentClick" class="pt-0">
		<h5 :class="{ 'error-color': !isEmailValid }" class="reg invite-title pa-2">{{ title }}</h5>
		<Row class="invite-container flex-align-center py-3 px-4 width-100">
			<SIcon name="email-invitation-chip" class="mr-2" />
			<h5 class="mail-text">{{ email }}</h5>
		</Row>
	</Col>
</template>

<script>
import { DataTypeEvaluator } from '@ply-io/data-types';
export default {
	name: 'ShareDialogInteractiveEmailInvite',
	props: {
		email: { type: String },
	},
	computed: {
		title() {
			return this.isEmailValid ? 'Invite and share with' : 'Enter a valid email address, to invite and share with';
		},
		isEmailValid() {
			const evaluator = new DataTypeEvaluator();
			return evaluator.isEmail(this.email);
		},
	},
	methods: {
		onContentClick(e) {
			if (!this.isEmailValid) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
	},
};
</script>

<style scoped lang="scss">
.invite-title {
	color: #292829;
	letter-spacing: 0px;
	&.error-color {
		color: #f44336;
	}
}
.mail-text {
	color: #292829;
	font-weight: 300;
	letter-spacing: 0px;
	text-transform: lowercase;
}
.invite-container {
	cursor: pointer;
	&:hover {
		background-color: #f5f5f5;
	}
}
</style>
